import React from 'react';
import { Link } from 'react-router-dom'; // Important: Use Link for SPA routing
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        {/* Left: Logo & Brand */}
        <div className="footer-brand">
          <img src="/images/logo2.png" alt="Sharanga Logo" className="footer-logo-img" />
          <h2>Sharanga Aqua Farms Pvt Ltd</h2>
          <p className="tagline">
            Nurtured with <strong>Precision</strong>, Delivered with <strong>Freshness</strong>.
          </p>
        </div>

        {/* Middle: Updated Quick Links using Link */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/operations">Operations</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/market">Market</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Right: Office Info */}
        <div className="footer-office">
          <h3>Our Office</h3>
          <p><strong>Address:</strong></p>
          <p>H.No. 3-74, Kothota, Mutyala Palli</p>
          <p>Mogalthuru, West Godavari</p>
          <p>Andhra Pradesh – 534281</p>
          <p><strong>Call us:</strong> +91 9985435789 , +91 81860 85043</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Sharanga Aqua Farms Pvt Ltd. All rights reserved.</p>
        <p>Designed And Developed By CalFin Team</p>
      </div>
    </footer>
  );
}

export default Footer;
